import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import config from '../../helpers/config';
import DuplicateEstimateButton from './DuplicateEstimateButtonConnector';
import RenameEstimateButton from './RenameEstimateButtonConnector';
import SaveIconButton from './SaveIconButtonConnector';
import ShareIconButton from './ShareIconButtonConnector';
import DownloadEstimateButton from './DownloadEstimateButtonConnector';
import PrintCommercialEstimate from './PrintCommercialEstimateConnector';
import SavedToMyAccountMessage from './Saving/SavedToMyAccountMessageConnector';
import ShareEstimateMessage from './ShareEstimateMessageConnector';

const EstimateHeader = props => (
  <div className="estimatesActions" key={`header-${props.designId}`}>
    <div className="leftDiv">
      <div className="desktop-only">
        <h3>
          <span className="truncateText" title={props.name}>{props.name}</span>
          {!props.isLockedOrOrdered && (
            <RenameEstimateButton />
          )}
        </h3>
      </div>
      <div className="tablet-mobile-only">
        <h3>
          <span className="truncateText" title={props.name}>{props.name}</span>
          <RenameEstimateButton />
        </h3>
      </div>
    </div>
    <div className="rightDiv">
      <div className="actions">
        {!props.isLockedOrOrdered && !props.isMandi && <SavedToMyAccountMessage />}
        {!props.isAutoReleaseDesign
        && !props.isLockedOrOrdered
        && !props.isMandi && <ShareEstimateMessage />}
        {!props.isAutoReleaseDesign
        && config.repId() !== null
        && !props.isLockedOrOrdered
        && !props.isMandi
        && <ShareIconButton />}
        {config.repId() === null && !props.isLockedOrOrdered && !props.isMandi &&
          <SaveIconButton />}
        {!props.isAutoReleaseDesign &&
        <Fragment>
          {config.repId() !== null && !props.hasInvalidItems && !props.isLockedOrOrdered
          && !props.hasDiscontinuedItems && !props.isMandi && !props.isTHD
          && <PrintCommercialEstimate repId={config.repId()} />}
          {!props.hasInvalidItems && !props.isLockedOrOrdered && !props.hasDiscontinuedItems
          && <DownloadEstimateButton />}
          {!props.hasInvalidItems && !props.disableDuplicate && !props.hasDiscontinuedItems
          && <DuplicateEstimateButton />}
        </Fragment>
        }
      </div>
    </div>
  </div>
);

EstimateHeader.propTypes = {
  name: PropTypes.string.isRequired,
  designId: PropTypes.string.isRequired,
  hasInvalidItems: PropTypes.bool.isRequired,
  hasDiscontinuedItems: PropTypes.bool.isRequired,
  disableDuplicate: PropTypes.bool.isRequired,
  isLockedOrOrdered: PropTypes.bool.isRequired,
  isMandi: PropTypes.bool.isRequired,
  isTHD: PropTypes.bool.isRequired,
  isAutoReleaseDesign: PropTypes.bool.isRequired,
};

export default EstimateHeader;
